import comp from "./ShortcutManagerWrapper";
export default comp;
